import React from "react";

const PaymentCancel: React.FC = () => {

  return (
    <>
      {/* Page Navigation */}
      <div className="collection_details_templet_banner d-sm-block d-none">
        <div className="page_navegation_area">
          <div className="container">
            <div className="page_navegation font_two">
              <p>
                <a href="/">Home</a> /{" "}
                <span className="active fw_700">Payment Cancelled</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Cancel Section */}
      <section className="payment_cancel_section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8 col-md-10">
              <div className="cancel_card" style={{
                background: '#fff',
                borderRadius: '12px',
                padding: '50px 30px',
                textAlign: 'center',
                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                margin: '50px 0'
              }}>
                {/* Cancel Icon */}
                <div className="cancel_icon" style={{ marginBottom: '30px' }}>
                  <svg
                    width="100"
                    height="100"
                    viewBox="0 0 100 100"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{ margin: '0 auto' }}
                  >
                    <circle cx="50" cy="50" r="50" fill="#EF4444" fillOpacity="0.1" />
                    <circle cx="50" cy="50" r="40" fill="#EF4444" />
                    <path
                      d="M35 35L65 65M65 35L35 65"
                      stroke="white"
                      strokeWidth="4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                {/* Cancel Message */}
                <h1 style={{
                  fontSize: '32px',
                  fontWeight: '700',
                  color: '#1a1a1a',
                  marginBottom: '15px'
                }}>
                  Payment Cancelled
                </h1>
                
                <p style={{
                  fontSize: '18px',
                  color: '#666',
                  marginBottom: '30px',
                  lineHeight: '1.6'
                }}>
                  Your payment was cancelled. No charges have been made to your account.
                </p>

                {/* Info Box */}
                <div style={{
                  background: '#fef2f2',
                  border: '2px solid #EF4444',
                  borderRadius: '8px',
                  padding: '20px',
                  marginBottom: '30px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'start', gap: '15px' }}>
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#EF4444"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      style={{ flexShrink: 0, marginTop: '2px' }}
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    <div style={{ textAlign: 'left', flex: 1 }}>
                      <h4 style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#991b1b',
                        marginBottom: '8px'
                      }}>
                        What Happened?
                      </h4>
                      <p style={{
                        fontSize: '14px',
                        color: '#7f1d1d',
                        margin: 0,
                        lineHeight: '1.5'
                      }}>
                        You cancelled the payment process. Your items are still in your cart and waiting for you.
                        You can return to your cart anytime to complete your purchase.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Reasons Box */}
                <div style={{
                  background: '#f8f9fa',
                  borderRadius: '8px',
                  padding: '20px',
                  marginBottom: '30px',
                  textAlign: 'left'
                }}>
                  <h4 style={{
                    fontSize: '18px',
                    fontWeight: '600',
                    color: '#1a1a1a',
                    marginBottom: '15px'
                  }}>
                    Need Help?
                  </h4>
                  <ul style={{
                    listStyle: 'none',
                    padding: 0,
                    margin: 0
                  }}>
                    <li style={{
                      display: 'flex',
                      alignItems: 'start',
                      gap: '10px',
                      marginBottom: '12px'
                    }}>
                      <span style={{
                        color: '#3b82f6',
                        fontSize: '16px',
                        flexShrink: 0,
                        marginTop: '2px'
                      }}>
                        •
                      </span>
                      <span style={{ color: '#666', fontSize: '14px' }}>
                        Changed your mind? Your cart items are saved for later
                      </span>
                    </li>
                    <li style={{
                      display: 'flex',
                      alignItems: 'start',
                      gap: '10px',
                      marginBottom: '12px'
                    }}>
                      <span style={{
                        color: '#3b82f6',
                        fontSize: '16px',
                        flexShrink: 0,
                        marginTop: '2px'
                      }}>
                        •
                      </span>
                      <span style={{ color: '#666', fontSize: '14px' }}>
                        Having payment issues? Try a different payment method
                      </span>
                    </li>
                    <li style={{
                      display: 'flex',
                      alignItems: 'start',
                      gap: '10px'
                    }}>
                      <span style={{
                        color: '#3b82f6',
                        fontSize: '16px',
                        flexShrink: 0,
                        marginTop: '2px'
                      }}>
                        •
                      </span>
                      <span style={{ color: '#666', fontSize: '14px' }}>
                        Questions about the product? Contact our support team
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Action Buttons */}
                <div style={{
                  display: 'flex',
                  gap: '15px',
                  justifyContent: 'center',
                  flexWrap: 'wrap'
                }}>
                  <a
                    href="/cart"
                    className="blue_btn"
                    style={{
                      textDecoration: 'none',
                      padding: '12px 30px',
                      fontSize: '16px',
                      fontWeight: '500',
                      borderRadius: '6px'
                    }}
                  >
                    Return to Cart
                  </a>
                  <a
                    href="/products?collection=Canvas"
                    style={{
                      textDecoration: 'none',
                      padding: '12px 30px',
                      fontSize: '16px',
                      fontWeight: '500',
                      borderRadius: '6px',
                      background: 'white',
                      border: '2px solid #3b82f6',
                      color: '#3b82f6',
                      display: 'inline-block'
                    }}
                  >
                    Continue Shopping
                  </a>
                </div>

                {/* Support Info */}
                <p style={{
                  fontSize: '14px',
                  color: '#999',
                  marginTop: '30px',
                  marginBottom: 0
                }}>
                  Need assistance? Contact us at{" "}
                  <a
                    href="mailto:support@digitalartstore.com"
                    style={{ color: '#3b82f6', textDecoration: 'none' }}
                  >
                    support@digitalartstore.com
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PaymentCancel;

